import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";

export default class HudView extends AbstractView {

    constructor(target, targetTime, targetPuzzleScore, languagePack) {
        super(target);
        this._targetTime = targetTime;
        this._targetPuzzleScore = targetPuzzleScore;
        this._languagePack = languagePack;
        this._status;
        this._timeTextfield = this._targetTime.timeTextfield;
        this._scoreTextfield = this._target.scoreTextfield;
        this._puzzleTextfield = this._target.puzzleTextfield;
        this._puzzleScoreTextfield = this._targetPuzzleScore.scoreTextfield;

        this._target.puzzleLabelTextfield.lineWidth = null;
        this._target.scoreLabelTextfield.lineWidth = null;
        this._targetTime.timeLabelTextfield.lineWidth = null;
        this._targetPuzzleScore.scoreLabelTextfield.lineWidth = null;
        
        this._target.puzzleLabelTextfield.text = this.getText("hud.puzzleLabel");
        this._target.scoreLabelTextfield.text = this.getText("hud.scoreLabel");
        this._targetTime.timeLabelTextfield.text = this.getText("hud.timeLabel");
        this._targetPuzzleScore.scoreLabelTextfield.text = this.getText("hud.puzzleScoreLabel");
    }

    /**
     * @param {Number} value - remaining time in msecs
     */
    setTime(value) {
        value = Math.max(value, 0);
        const secs = Math.floor(value / 1000) % 60;
        const mins = Math.floor(value / 60000) % 60;
        const hours = Math.floor(value / 3600000) % 24;
        let str = padTime(mins) + ":" + padTime(secs);
        if (hours > 0) {
            str = hours + ":" + str;
        }
        this._timeTextfield.text = str;
    }

    setPuzzleIndex(index) {
        this._puzzleTextfield.text = index;
    }

    setScore(n) {
        this._scoreTextfield.text = this._getScoreAsPerc(n);
    }

    /**
     * @param {Number} n in range [0..1]
     */
    setPuzzleScore(n) {
        this._puzzleScoreTextfield.text = this._getScoreAsPerc(n);
    }

    /**
     * @param {Number} n in range [0..1]
     */
    _getScoreAsPerc(n) {
        return Math.round(Math.min(1, Math.max(0, n)) * 100) + "%";
    }

}

HudView.START;

function padTime(str) {
    return ("0" + str).substr(-2);
}